export default __webpack_public_path__ + "static/media/ico_X.6cf38895.svg";